"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_class_decorator_1 = require("vue-class-decorator");
var vue_property_decorator_1 = require("vue-property-decorator");
var Booking_1 = require("../../../types/Booking");
var BookingEditCreate = /** @class */ (function (_super) {
    __extends(BookingEditCreate, _super);
    function BookingEditCreate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "BookingEditCreate";
        _this.bookingStatuses = [
            {
                value: 'complete',
                text: 'Abgeschlossen'
            },
            {
                value: 'failed',
                text: 'Fehlgeschlagen'
            },
            {
                value: 'pending',
                text: 'Warten auf Bezahlung'
            },
            {
                value: 'canceled',
                text: 'Storniert/Abgebrochen'
            }
        ];
        _this.selectedUser = undefined;
        _this.selectedCourse = undefined;
        _this.requiredRule = function (v) { return !!v || 'Die ist ein Pflichtfeld'; };
        return _this;
    }
    BookingEditCreate.prototype.getUserIdFromUrlQuery = function () {
        var _a;
        var urlSearchParams = new URLSearchParams(window.location.search);
        return (_a = urlSearchParams.get('student_id')) !== null && _a !== void 0 ? _a : '';
    };
    BookingEditCreate.prototype.created = function () {
        var _this = this;
        var student;
        if (this.create) {
            student = this.students.find(function (student) { return student.id === parseInt(_this.getUserIdFromUrlQuery()); });
        }
        else {
            student = this.students.find(function (student) { return student.id === _this.booking.user_id; });
            var course = this.courses.find(function (course) { return course.id === _this.booking.course_id; });
            this.selectedCourse = course ? course.id : undefined;
        }
        this.selectedUser = student ? student.id : undefined;
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], BookingEditCreate.prototype, "create", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)(Booking_1.Booking),
        __metadata("design:type", Booking_1.Booking)
    ], BookingEditCreate.prototype, "booking", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Array, default: function () { return []; } }),
        __metadata("design:type", Array)
    ], BookingEditCreate.prototype, "students", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Array, default: function () { return []; } }),
        __metadata("design:type", Array)
    ], BookingEditCreate.prototype, "courses", void 0);
    BookingEditCreate = __decorate([
        (0, vue_class_decorator_1.Component)({})
    ], BookingEditCreate);
    return BookingEditCreate;
}(vue_1.default));
exports.default = BookingEditCreate;
var C = /** @class */ (function () {
    function C() {
    }
    return C;
}());
function test() {
    var c = new C();
    if (c instanceof C) {
    }
}
function instanceOfA(object) {
    return 'member' in object;
}
